"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = void 0;
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const utils_storage_1 = require("@unboared/utils.storage");
exports.useTheme = (0, utils_storage_1.createPersistStorage)('_theme', (set) => ({
    theme: base_ui_theme_themes_1.unboaredTheme.dark,
    setTheme: (new_theme) => set({ theme: new_theme }),
    toggleDarkTheme: () => {
        set(state => ({ theme: state.theme.mode === "dark" ? base_ui_theme_themes_1.unboaredTheme.light : base_ui_theme_themes_1.unboaredTheme.dark }));
    }
}));
//# sourceMappingURL=theme.js.map